module.exports = __webpack_public_path__ + "img/roleDoctor.02bac7b5.svg";